import { fetchApi } from '../../../lib/fetchApi';
import { UpdateSurveyDetail } from '../types';


export const changeIAValuesSurveyDetail= async (idSurvey: number, values: UpdateSurveyDetail): Promise<void> => {
    await fetchApi.put(`/surveys/detail/${idSurvey}`, values);
};


export const deleteTopicSurveyDetail = async (idSurvey: number, topicIdToRemove: number): Promise<void> => {
    await fetchApi.put(`/topics/${idSurvey}/${topicIdToRemove}`, null);
};
